import { filterContentBoxesForPresentDay } from "./contentBoxPresentQuery";
import { buildPrintViewDateDataFromKey } from "./printViewDateFilter";

export function coversMultipleDays(activeDates = {}) {
  const { startDate, endDate } = activeDates;

  if (Array.isArray(startDate)) {
    return startDate.length > 1;
  }

  if (!startDate || !endDate) {
    return false;
  }

  return String(startDate) !== String(endDate);
}

export function isExpandingToMultiDay(previousDates = {}, nextDates = {}) {
  return !coversMultipleDays(previousDates) && coversMultipleDays(nextDates);
}

export function isBoxActiveOnMultipleDaysInWeek(box = {}, weekScope = {}, settings = {}) {
  const dateKeys = Array.isArray(weekScope?.dateKeys) ? weekScope.dateKeys : [];
  if (dateKeys.length < 2) return false;

  const matchingDays = dateKeys.filter((dateKey) => {
    const dateData = buildPrintViewDateDataFromKey(dateKey);
    return filterContentBoxesForPresentDay([box], dateData, {
      ...settings,
      useActiveDates: settings?.useActiveDates !== false,
    }).length > 0;
  });

  return matchingDays.length > 1;
}
